import { removeMaskPhone } from "../functionsGlobal";
import { getToken } from "../services/auth";
import ParametroServices from "../services/parametro";

export const useParameter = () => {

    const saveEstablishiment = async({...rest}) => {
        try {
            
            const {site_telefone} = rest
            let resultTelefone = removeMaskPhone(site_telefone);
            delete rest.site_telefone;
            const service = new ParametroServices();
            const result = await service.saveEstablishmentDice({
                cnpj: getToken('CNPJ'),
                ...rest,
                site_telefone:resultTelefone
                
            })

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const saveMenu = async ({...rest}) => {
        try {
            const {file, fileBanner} = rest;
            delete rest.file;
            delete rest.fileBanner;
            delete rest.site_banner_descricao;
            delete rest.site_logo_descricao;
            delete rest.site_url_banner;
            delete rest.site_url_logo;

            const service = new ParametroServices();
            const result = await service.saveMenu({
                cnpj: getToken('CNPJ'),
                ...rest,
                site_url_img:`https://sistefood.com.br/img/${getToken('CNPJ')}/`,
                fotoLogo:file,
                fotoBanner:fileBanner

            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }  
    }

    const saveDelivery = async ({...rest}) => {
        try {
            const {site_frete} = rest
            let valueFreight = site_frete ?? site_frete?.replace('.', '');
            delete rest.site_frete
            const service = new ParametroServices();
            const result = await service.saveDelivery({
                cnpj: getToken('CNPJ'),
                site_frete: valueFreight,
                ...rest

            });
            
            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }  
    }

    const saveTable = async ({...rest}) => {
        try {
            const {valor_couvert, informa_atendente} = rest;
            let valueCouvert = valor_couvert.replace('.', '');

            const service = new ParametroServices();
            const result  = await service.saveTable({
                cnpj: getToken('CNPJ'),
                informa_atendente: informa_atendente ? 'S' : 'N',
                valor_couvert: valueCouvert

            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }  

    }

    const saveApp = async ({...rest}) => {
        try {
            const {senha_adm_apk, senha_cli_apk, tela_apk_comanda, trabalha_num_mesa, permitefinalizarmesaapp, tela_apk_mesa} = rest;
            const service = new ParametroServices();
            const result  = await service.saveApp({
                cnpj: getToken('CNPJ'),
                senha_adm_apk,
                senha_cli_apk,
                tela_apk_comanda : tela_apk_comanda ? 'S' : 'N',
                trabalha_num_mesa: trabalha_num_mesa ?  'S' : 'N',
                permitefinalizarmesaapp: permitefinalizarmesaapp ? 'S' : 'N',
                tela_apk_mesa: tela_apk_mesa ? 'S' : 'N'

            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }  
    }

    const getEstablishmentDice = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getEstablishmentDice({
                cnpj: getToken('CNPJ'),
            })

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getMenu = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getMenu({
                cnpj: getToken('CNPJ')
            });   

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getParameterGeneral = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getAllParameter({
                cnpj: getToken('CNPJ')
            });   

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getDelivery = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getDelivery({
                cnpj: getToken('CNPJ')
            });

            if(result.success) return {success: true, data: result.data};
                return {success: false, data: []};
        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }

    }

    const getTable = async () => {
        try {
            const service = new ParametroServices();
            const result  = await service.getTable({
                cnpj: getToken('CNPJ'),
            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};

        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getApp = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getApp({
                cnpj:getToken('CNPJ')
            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};

        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getDfe = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getDfe({
                cnpj:getToken('CNPJ')
            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};

        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const getLoadingDfe = async () => {
        try {
            const service = new ParametroServices();
            const result = await service.getLoadingDfe({
                cnpj: 'sisteinfocontrole',
                cliente:{
                    cnpj:getToken('CNPJ')
                }
            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};

        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    const saveDfe = async ({...rest}) => {
        try {
            
            rest.webserambiente = rest.checkProd ? 0 : 1;
            rest.webserscan =  rest.webserscan ? 'S' : 'N';
            rest.emailssl =  rest.emailssl ? 'S' : 'N';
            rest.emitcrt = rest.emitcrt.length === 0 ? '1' : rest.emitcrt

            delete rest.checkHomo;
            delete rest.checkProd;
            rest['certificado'] = rest.certificate
            delete rest.certificate;

            const service = new ParametroServices();
            const result = await service.saveDfe({
                cnpj:getToken('CNPJ'),
                ...rest
            });

            if(result.success) return {success: true, data: result.data};
            return {success: false, data: []};

        } catch (error) {
            console.log(error);
            return {success: false, data: []};
        }
    }

    return{
        saveEstablishiment, getEstablishmentDice, getMenu, saveMenu, getDelivery, getParameterGeneral,
        saveDelivery, getTable, saveTable, getApp, saveApp, getDfe, saveDfe, getLoadingDfe
    }
}